import { httpClient } from "./RestService";

export const getAll = async (assignmentId) => {
  return await httpClient().get(
    "/v1/education/cs/assmnt/gr/list/" + assignmentId
  );
};
